import { REPORTS_NAMESPACE_TRANSLATIONS } from "./reports-namespace-translations.ts"
import { REPORTS_TRANSLATIONS } from "./reports-translations.ts"
import { COW_STATUS_TRANSLATIONS } from "@/locales/pl/cow-status-translations.ts"
import { PL_MAIN_TRANSLATIONS } from "@/locales/pl/main-translations.ts"

export const PL_TRANSLATIONS = {
  translation: {
    ...PL_MAIN_TRANSLATIONS,
    ...REPORTS_TRANSLATIONS,
  },
  cowStatus: {
    ...COW_STATUS_TRANSLATIONS,
  },
  reports: { ...REPORTS_NAMESPACE_TRANSLATIONS },
}
